import {gsap} from "gsap";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {NineToFive} from "../../NineToFive";
import {NineToFiveGameAssets} from "../../NineToFiveGameAssets";
import {NineToFiveSymbol, SymbolArgs} from "./NineToFiveSymbol";
import {NineToFiveStatics} from "../../config/NineToFiveStatics";

export class NineToFiveWinCapSymbol extends NineToFiveSymbol {

    constructor(args:SymbolArgs) {
        super(args);
        if (args.reelID != 2 || (args.reelPosition + 1) != args.bigSymbolData.actualSymbolIndex) {
            this.view.removeChild(this.mainSprite);
            this.view.removeChild(this.spinSprite);
            this.view.removeChild(this.overlay);
        } else {
            const adjustedPosition = args.bigSymbolData.topToBottom
                                     ? NineToFiveStatics.SYMBOL_HEIGHT * 1.5
                                     : -NineToFiveStatics.SYMBOL_HEIGHT * 1.5
            //this.moveToNormalOverLayer()
            this.moveToNormalLayer();
            this.mainSprite.position.set(0, adjustedPosition);

            this.overlay.width = NineToFiveStatics.SYMBOL_WIDTH * 5;
            this.overlay.height = NineToFiveStatics.SYMBOL_WIDTH * 4 + 56;
            this.overlay.position.set(0, adjustedPosition);

            this.view.removeChild(this.spinSprite);
            this.mainSprite.alpha = 1;
        }
    }
}

